import MainService from "../Main";
import * as operations from "./ServiceBusinessModelGroup.graphql.js";

class ServiceBusinessModelGroupService extends MainService {
	constructor(options) {
		super(options);
		this.patch(operations);
	}
}

export default ServiceBusinessModelGroupService;
